/**
 * THIS CODE IS AUTOMATICALLY GENERATED by @geenius/analytics codegen.
 *
 * Template version: 1.34-r3
 * Generated at: 2026-05-19
 * Convex SDK: ^1.34.0
 *
 * DO NOT EDIT THIS FILE MANUALLY.
 * To regenerate, run: pnpm codegen
 * @module
 */

import { anyApi, componentsGeneric } from "convex/server";

export const api = anyApi;
export const internal = anyApi;
export const components = componentsGeneric();
